export default __webpack_public_path__ + "static/media/ReglasX+YLaboratorio.2e6c8b18.pdf";